// 存储当前行的购物车数据
export default {
  namespaced: true,
  state: {
    rowData: {},//当前行的数据容器
  },
  mutations: {
    changeRowData (state, payload) {
      state.rowData = payload
    }
  }
}